
import { UseFormRegister } from 'react-hook-form';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import type { FormData } from '../types';

interface EmployeeCountFieldsProps {
  register: UseFormRegister<FormData>;
}

export const EmployeeCountFields = ({ register }: EmployeeCountFieldsProps) => {
  return (
    <div className="space-y-2">
      <Label>Employee Count Range</Label>
      <div className="flex items-center gap-2">
        <div className="w-1/2">
          <div className="flex items-center">
            <Input
              id="min_employee_count"
              type="number"
              className="w-full"
              {...register('min_employee_count', { 
                setValueAs: (value) => value === "" ? null : parseInt(value) 
              })}
              placeholder="Min"
            />
          </div>
        </div>
        <span className="text-center">to</span>
        <div className="w-1/2">
          <div className="flex items-center">
            <Input
              id="max_employee_count"
              type="number"
              className="w-full"
              {...register('max_employee_count', { 
                setValueAs: (value) => value === "" ? null : parseInt(value) 
              })}
              placeholder="Max"
            />
          </div>
        </div>
      </div>
      <p className="text-xs text-muted-foreground">
        Leave blank if unknown or not applicable
      </p>
    </div>
  );
};
